export interface ParsedOutput {
  backup_app_service_principal_id?: string;
  restore_app_application_id?: string;
  restore_app_service_principal_id?: string;
  managed_identity_resource_id?: string;
}

type OutputFormat = 'terraform' | 'bash';

export function parseOutput(
  input: string,
  format: OutputFormat
): ParsedOutput | null {
  try {
    const parsed = JSON.parse(input.trim());

    if (format === 'bash') {
      return parsed as ParsedOutput;
    }

    // Terraform: unwrap { value } from each field
    return Object.fromEntries(
      Object.entries(parsed).map(([key, val]) => [
        key,
        (val as { value: string }).value,
      ])
    ) as ParsedOutput;
  } catch {
    return null;
  }
}
